@if (initialized && dto) {
    <div class="surface-card p-3 border-round flex flex-column gap-3">

        <!-- Partner + Status -->
        <div class="flex align-items-center justify-content-between gap-2">
            <div class="flex align-items-center gap-2">
                <i class="fa-regular fa-handshake text-primary"></i>
                <span class="font-medium">{{ dto.hgPartnerDtoName || 'Unbekannter Partner' }}</span>
            </div>

            @switch (dto.status) {
                @case (HgImportStatusInternalEnum.NEW) {
                    <p-tag severity="info" value="Neu"></p-tag>
                }
                @case (HgImportStatusInternalEnum.PROCESSING) {
                    <p-tag severity="warn" value="In Bearbeitung"></p-tag>
                }
                @case (HgImportStatusInternalEnum.INGESTION) {
                    <p-tag severity="warn" value="Datenaufnahme"></p-tag>
                }
                @case (HgImportStatusInternalEnum.DELEGATED) {
                    <p-tag severity="info" value="Delegiert"></p-tag>
                }
                @case (HgImportStatusInternalEnum.COMPLETED) {
                    <p-tag severity="success" value="Abgeschlossen"></p-tag>
                }
                @case (HgImportStatusInternalEnum.ERROR) {
                    <p-tag severity="danger" value="Fehler"></p-tag>
                }
            }
        </div>

        <!-- Dokument-Name -->
        @if (dto.dmDocumentDtoName) {
            <div class="flex align-items-center gap-2 text-color-secondary">
                <i class="fa-regular fa-file-lines"></i>
                <span class="text-sm">{{ dto.dmDocumentDtoName }}</span>
            </div>
        }

        <!-- Kurze EI-Progress-Anzeige -->
        @if (dto.eiImportDtoId) {
            @if (eiImportLoading) {
                <p-skeleton width="100%" height="1.25rem"></p-skeleton>
            } @else if (eiImport) {
                <div class="flex align-items-center gap-2 text-sm">
                    <i class="fa-regular fa-database text-color-secondary"></i>
                    <span class="text-color-secondary">
                        {{ eiImport.recordCount ?? 0 }} Datensätze
                        @if (eiImport.recordsErrors && eiImport.recordsErrors > 0) {
                            / <span class="text-red-500 font-medium">{{ eiImport.recordsErrors }} Fehler</span>
                        }
                    </span>
                </div>
            }
        }

        <!-- Fehler-Icon bei status=ERROR -->
        @if (dto.status === HgImportStatusInternalEnum.ERROR) {
            <div class="flex align-items-center gap-2 text-red-500">
                <i class="fa-regular fa-triangle-exclamation"></i>
                <span class="text-sm">Der Import ist fehlgeschlagen.</span>
            </div>
        }

        <!-- Details öffnen -->
        <div class="flex justify-content-end">
            <p-button
                    label="Details öffnen"
                    icon="fa-regular fa-arrow-up-right-from-square"
                    severity="secondary"
                    [text]="true"
                    (onClick)="openDetails()">
            </p-button>
        </div>
    </div>
}
